<template>
    <div class="panel">
        <h1>Not Found</h1>
        <p>Sorry, we couldn't find what you were looking for</p>
        <router-link to="/home" class="btn btn-primary">Go Home</router-link>
    </div>
</template>

<script>
export default {
    name: 'notFound',
    mounted () {
    },
    created () {
        this.$router.push({name: 'lottery',})
    },
}
</script>

<style lang="sass" scoped>
</style>
